export default function() {
  return {
    instruments: [],
    instrument: {},
    lists: []
  }
}
